import { render, staticRenderFns } from "./jobTransferDetail.vue?vue&type=template&id=724ed4ba&scoped=true&"
import script from "./jobTransferDetail.vue?vue&type=script&lang=js&"
export * from "./jobTransferDetail.vue?vue&type=script&lang=js&"
import style0 from "./jobTransferDetail.vue?vue&type=style&index=0&id=724ed4ba&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724ed4ba",
  null
  
)

export default component.exports